import React              from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes          from 'prop-types';
import Image              from '@material-ui/icons/Image';
import Input              from '@material-ui/core/Input';
import Paper              from '~/components/Paper';
import InputControl       from '~/components/Input/InputControl';
import InputNumber        from '~/components/Input/InputNumber';
import InputDropzone      from '~/components/Input/InputDropzone';
import GridContainer      from '~/components/GridContainer';
import GridItem           from '~/components/GridItem';
import Form               from '~/containers/Form';
import InputCheckBox      from '~/components/Input/InputCheckBox';
import TourImageRecord    from '~/records/TourImageRecord';

const attrName = (attr) => TourImageRecord.hummanAttributeName(attr);

function TourImageItem({record, handleChange, loading, onSubmit }) {
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();

  return (
    <Form onSubmit={onSubmit} isPersisted={isPersisted}>
      <Paper
        Icon={Image}
        iconColor={isPersisted ? 'purple' : 'green'}
        title={t('TourImage')}
        loading={loading}
      >
        <GridContainer>
          <GridItem xs={12} md={6}>
            <InputControl
              name='name'
              value={record.get('name')}
              disabled={loading}
              required={true}
              label={attrName('name')}
              inputComponent={Input}
              onChange={handleChange}
            />
          </GridItem>
          <GridItem xs={4} md={2}>
            <InputControl
              name='sorter'
              value={record.get('sorter')}
              disabled={loading}
              required={true}
              label={attrName('sorter')}
              inputComponent={InputNumber}
              InputProps={{
                config:{allowDecimal: false, requireDecimal: false},
              }}
              onChange={handleChange}
            />
          </GridItem>
          <GridItem xs={1} md={1}>
            <InputControl
              value={record.get('is_active')}
              name="is_active"
              disabled={loading}
              label={attrName('is_active')}
              inputComponent={InputCheckBox}
              onChange={handleChange}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={10} md={5}>
            <InputControl
              name='image_base64'
              disabled={loading}
              required={true}
              label={attrName('image_base64')}
              value={record.get('image_base64')}
              inputComponent={InputDropzone}
              onChange={handleChange}
            />
          </GridItem>
        </GridContainer>
      </Paper>
    </Form>
  );
}

TourImageItem.propTypes={
  loading:      PropTypes.bool,
  record:       PropTypes.instanceOf(TourImageRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit:     PropTypes.func.isRequired,
};

TourImageItem.defaultProps={
  loading: false,
};
export default TourImageItem;
